import ClaimType from 'models/claims/claimType/Model.ClaimType';
import Model from 'models/Model';
import Dealer from '../dealer/Model.Dealer';

export default class DealerClaimType
  extends Model<Model.IDealerClaimType>({ icon: 'if-login' })
  implements Model.Instance<Model.IDealerClaimType>
{
  id: number;
  claimTypeId: number;
  claimType?: ClaimType;
  dealerId: number;
  dealer?: Dealer;
  isClaimTypeAutomationEnabled?: boolean;

  constructor(
    data: Partial<Model.IDealerClaimType> | Utils.FormData<Model.IDealerClaimType>,
    language?: Locale.Languages
  ) {
    super(
      {
        dealer: Dealer,
        claimType: ClaimType,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }
}
